import { useAppState } from '@/shared/hooks/useAppState'
import useI18n from '@/shared/hooks/usei18n'
import { PopoverButton as PopoverButtonHeadless } from '@headlessui/react'
import { CaretDownIcon } from '@/common/components/icons'
import { Popover, PopoverPanel, Transition } from '@headlessui/react'
import { Button, PopoverToggleButton } from '@/common'
import { useNavigate } from 'react-router-dom'
import cx from 'classnames'
import { PlusIcon } from '@heroicons/react/24/solid'
import { useSession } from '@/shared/hooks/useSession'

export default function DeclarantsMenu({
  declarantName,
  declarants
}: {
  declarantName: string
  declarants: {
    id: string
    name: string
    isActive: boolean
  }[]
}) {
  const { t } = useI18n()
  const navigate = useNavigate()
  const { setSelectedDeclarantId } = useAppState()
  const { session: { role } } = useSession()
  const isAdmin = role === 'ADMIN'

  const handleNewDeclarantClick = () => {
    navigate('/cbam-reporting/create-declarant')
  }

  const onDeclarantClick = (declarantId: string) => {
    setSelectedDeclarantId(declarantId)
    navigate(`/cbam-reporting/${declarantId}`)
  }

  return (
    <Popover>
      <PopoverToggleButton>
        <div className="space-y-1 text-left">
          <div className="font-semibold text-sm break-words">{declarantName}</div>
        </div>
        <CaretDownIcon className="flex-shrink-0 size-6" />
      </PopoverToggleButton>
      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <PopoverPanel
          transition
          anchor="bottom end"
          className="z-40 transition shadow-dropdown border translate-x-8 rounded-xs bg-white duration-200 ease-in-out [--anchor-gap:8px] data-[closed]:-translate-y-1 data-[closed]:opacity-0"
        >
          <div className="space-y-1 min-w-56 max-w-72">
            <section className="space-y-1 px-2 py-2">
              {declarants.map(declarant => (
                <PopoverButtonHeadless
                  as="button"
                  key={declarant.id}
                  className={cx(
                    'border w-full text-sm text-left p-2 rounded-xs font-medium',
                    declarant.isActive && 'bg-green-500 border-green-600'
                  )}
                  onClick={() => onDeclarantClick(declarant.id)}
                >
                  {declarant.name}
                </PopoverButtonHeadless>
              ))}
            </section>
            {isAdmin && <section className="px-2 py-2 border-t">
              <PopoverButtonHeadless
                as={Button}
                onClick={handleNewDeclarantClick}
                className="w-full"
                variant="subtle"
                icon={<PlusIcon />}
              >
                {t('common:navbar.newDeclarant')}
              </PopoverButtonHeadless>
            </section>}
          </div>
        </PopoverPanel>
      </Transition>
    </Popover>
  )
}
